import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiAutenticacaoService } from '../../services/api-autenticacao.service';

export const somenteAlunoEadGuard: CanActivateFn = () => {

  const apiAuth = inject(ApiAutenticacaoService);
  const router = inject(Router);
  const usuario = apiAuth.usuarioLogado();

  if (!usuario) { return false; }

  const ehAlunoEad = usuario.tipoUsuario === 1 && usuario.instituto?.trim()?.toUpperCase() === 'SEPI';
  return ehAlunoEad ? true : router.parseUrl('/sistemas');
};
